module.exports = __webpack_public_path__ + "static/media/remote2.8c9deb09.jpg";